/**
 * Hook to fetch a single transfer by ID.
 */
import { useState } from 'react'

import { customFetch } from '../utils/customFetch'
import { Transfer } from '../interfaces/Transfer'

import { makeUrlTransfer } from './connectionData'

const useTransferFetcher = () => {
  const [errorTransfer, setErrorTransfer] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchTransfer = async (id: string): Promise<Transfer | null> => {
    setLoading(true)
    try {
      const apiUrl = makeUrlTransfer(id)
      const data = await customFetch<Transfer>(apiUrl)
      setErrorTransfer(null)

      return data
    } catch (err) {
      const myErr = err instanceof Error ? err : new Error('Error desconocido')
      setErrorTransfer(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  return { errorTransfer, loading, fetchTransfer }
}

export default useTransferFetcher
